import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { atlImageSliderSwiperOptions } from '@atlas-workspace/shared/directives';
import { ModalHelpersService } from '@atlas-workspace/shared/modals';
import { DocumentModel, LayoutProductType, ProductListItemModelCPB, ProductModel } from '@atlas-workspace/shared/models';
import { ModalFacadeService } from '@atlas-workspace/shared/service';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';
import { filter, finalize, take } from 'rxjs/operators';

import { OptionsService } from '../../services/options.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'atl-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
  providers: [OptionsService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailsModalComponent implements OnInit {
  @Input() typeId!: number;
  @Input() categoryId!: number;
  @Input() layoutTypeId!: number;
  @Input() projectId!: number;
  @Input() productId!: number;
  @Input() unitId!: number;
  @Input() product!: ProductModel;
  @Input() readonly designLines = false;
  @Input() readonly optionDesignLineProducts = false;
  @Input() noStandartDeliveryProduct: null | ProductListItemModelCPB = null;
  @Input() type!: LayoutProductType;
  @Input() showPrices = true;
  @Input() readonly typeName?: string;

  readonly imageSliderOptions = cloneDeep({
    ...atlImageSliderSwiperOptions,
    pagination: false
  });
  public productTitle!: string;
  public loading = false;
  public isTablet = false;

  constructor(
    protected modalFacadeService: ModalFacadeService,
    protected optionsService: OptionsService,
    protected cdr: ChangeDetectorRef,
    protected modalHelpersService: ModalHelpersService,
    protected translateService: TranslateService,
    protected activeModal: NgbActiveModal,
    protected readonly router: Router
  ) {}

  ngOnInit(): void {
    if (!this.product) {
      this.getProductDetails();
    }

    this.router.events
      .pipe(
        untilDestroyed(this),
        filter((e): e is NavigationEnd => {
          return e instanceof NavigationEnd;
        })
      )
      .subscribe(() => this.modalFacadeService.closeModal());
  }

  closeModal(): void {
    this.modalFacadeService.closeModal();
  }

  onPreviewDocument(document: DocumentModel): void {
    this.modalHelpersService.previewDocument(document, true);
  }

  protected getProductDetails(): void {
    if (!this.productId) {
      return;
    }
    this.loading = true;
    this.optionsService
      .getProductDetails(this.projectId, this.layoutTypeId, this.categoryId, this.typeId, this.productId, this.unitId)
      .pipe(
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: ProductModel) => {
        this.product = result;
        this.productTitle = `${this.product.title} ${this.translateService.instant('Shared.Button.Details')}`;
        this.cdr.markForCheck();
      });
  }

  public setIsTablet(isTablet: boolean): void {
    this.isTablet === isTablet || (this.isTablet = isTablet);
  }

  afterInitSwiperHandler(): void {
    queueMicrotask(() => this.cdr.detectChanges());
  }
}
